module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Regular.0a78c101.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/AvenirNextLTPro-Regular.woff
// module id = 223
// module chunks = 0